import intercom from '@services/intercom';
import auth from './auth';

async function start() {
  try {
    const cognitoSession = await auth.getCurrentSession();
    const cognitoUser = cognitoSession.tokens?.idToken?.payload;
    const intercomHash = (cognitoUser?.intercom_hash_web || null) as string | null;
    if (cognitoUser) {
      intercom.boot({
        email: (cognitoUser?.email ?? '') as string,
        name: `${cognitoUser?.given_name ?? ''} ${cognitoUser?.family_name ?? ''}`,
        userHash: intercomHash,
        userId: cognitoUser?.sub,
      });
    } else {
      intercom.boot({});
    }
  } catch (err: any) {
    // noop
  }
}

let hasInitialized = false;
export default (() => {
  if (!hasInitialized) {
    // XXX: Not the greatest way to do this but the Intercom javascript api requires the widget to be initialized before using any of it's methods. Therefore we must explicitly call the boot method here should the user refresh the page while logged in.
    auth
      .getCurrentSession()
      .then(async (cognitoSession) => {
        const cognitoUser = cognitoSession.tokens?.idToken?.payload;
        const intercomHash = (cognitoUser?.intercom_hash_web || null) as string | null;
        if (cognitoUser && cognitoUser?.sub) {
          intercom.boot({
            email: cognitoUser.email,
            name: `${cognitoUser?.given_name} ${cognitoUser?.family_name}`,
            userHash: intercomHash,
            userId: cognitoUser?.sub,
          });
        } else {
          intercom.boot({});
        }
      })
      .catch(() => {
        // noop: do nothing, user is not signed in
      });
    hasInitialized = true;
  }
  return {
    close: intercom.close,
    hide: intercom.hide,
    identify: intercom.boot,
    show: intercom.show,
    start,
    trackEvent: intercom.trackEvent,
    update: intercom.update,
  };
})();
